import { render, staticRenderFns } from "./AccidentBasicInfo.vue?vue&type=template&id=75eafc82&scoped=true&"
import script from "./AccidentBasicInfo.vue?vue&type=script&lang=js&"
export * from "./AccidentBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eafc82",
  null
  
)

export default component.exports